module.exports = __webpack_public_path__ + "assets/img/9d0650b223d72423ca1b0dd8d28ee478.svg";